import React, { Dispatch, FC, useState } from 'react';
import { Dialog } from '@mui/material';
import { SetDraftResponse } from 'api/Responses/SetResponses';
import { SetAction } from 'reducers/DraftReducer/draftActions';
import SelectItem from './Workflows/SelectItem';
import SelectPart from './Workflows/SelectPart';
import SelectTray from './Workflows/SelectTray';

interface SetModalProps {
  open: boolean;
  close: () => void;
  draft: SetDraftResponse;
  dispatchDraft: Dispatch<SetAction>;
  initialTray?: string;
}

export type ModalContentType = 'selectItem' | 'selectTray' | 'selectPart';

const SetModal: FC<SetModalProps> = ({ open, close, draft, dispatchDraft, initialTray }) => {
  // Content displayed in the modal
  const [modalContent, setModalContent] = useState<ModalContentType>('selectItem');

  // Props passed to workflows
  const workflowProps = {
    selectItem: { setModalContent },
    selectTray: { set: draft, setModalContent, close, dispatchDraft },
    selectPart: {
      initialTray,
      setModalContent,
      close,
      dispatchDraft,
      trays: Object.keys(draft.trays),
      draftTrays: draft.trays,
    },
  };

  // Closes the modal and resets the modal state after animation
  const handleClose = (): void => {
    close();
    setTimeout(() => setModalContent('selectItem'), 500);
  };

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="md">
      {
        {
          // Renders the required workflow
          selectTray: <SelectTray {...workflowProps.selectTray} />,
          selectPart: <SelectPart {...workflowProps.selectPart} />,
          selectItem: <SelectItem {...workflowProps.selectItem} />,
        }[initialTray ? 'selectPart' : modalContent]
      }
    </Dialog>
  );
};

export default SetModal;
